export default __webpack_public_path__ + "static/media/andrey.c0801db5.webp";